import { supabase } from '../supabaseClient'

/**
 * Serviço para envio de templates oficiais do WhatsApp via Edge Function
 * Apenas nome do template, linguagem e parâmetros - o resto o Edge resolve
 */
class WABAService {
  /**
   * Envia template oficial do WhatsApp
   * @param {string} telefone - Número do destinatário (ex: 5511999999999)
   * @param {string} templateName - Nome do template aprovado na Meta
   * @param {array} parameters - Array de parâmetros [{ type: 'text', text: 'valor' }]
   * @param {string} languageCode - Código do idioma (default: pt_BR)
   */
  async enviarTemplate(telefone, templateName, parameters = [], languageCode = 'pt_BR') {
    try {
      // Formatar telefone (somente números)
      const numeroFormatado = telefone.replace(/\D/g, '')

      const { data, error } = await supabase.functions.invoke('send-whatsapp', {
        body: {
          to: numeroFormatado,
          templateName: templateName,
          languageCode: languageCode,
          parameters: parameters
        }
      })

      if (error) throw error

      return {
        sucesso: true,
        messageId: data.messages?.[0]?.id,
        dados: data
      }
    } catch (error) {
      console.error('❌ Erro ao enviar template WABA:', error)
      return {
        sucesso: false,
        erro: error.message
      }
    }
  }

  /**
   * Envia mensagem de boas-vindas
   * @param {string} telefone 
   * @param {string} nomeCliente 
   * @param {string} nomeAssinante 
   */
  async enviarBoasVindas(telefone, nomeCliente, nomeAssinante) {
    // Buscar nome do template no banco
    const { data: template } = await supabase
      .from('whatsapp_templates')
      .select('wa_template_name')
      .eq('message_key', 'boas_vindas')
      .eq('ativo', true)
      .maybeSingle()

    const templateName = template?.wa_template_name || 'boas_vindas_clickpag'

    // Parâmetros do template: {{1}} = nomeCliente, {{2}} = nomeAssinante
    const parameters = [
      { type: 'text', text: nomeCliente },
      { type: 'text', text: nomeAssinante }
    ]

    return await this.enviarTemplate(telefone, templateName, parameters, 'pt_BR')
  }

  /**
   * Envia lembrete de cobrança
   * @param {string} telefone 
   * @param {object} dados { nomeCliente, valor, dataVencimento, nomeAssinante, tipo: 'antes'|'dia'|'atraso' }
   */
  async enviarCobranca(telefone, dados) {
    const { nomeCliente, valor, dataVencimento, nomeAssinante, tipo = 'dia' } = dados

    // Buscar template baseado no tipo
    const messageKey = tipo === 'antes' ? 'pre_due_3days' : 
                       tipo === 'atraso' ? 'overdue' : 'due_day'

    const { data: template } = await supabase
      .from('whatsapp_templates')
      .select('wa_template_name')
      .eq('message_key', messageKey)
      .eq('ativo', true)
      .maybeSingle()

    const templateName = template?.wa_template_name || `cobranca_${tipo}`

    // Parâmetros: {{1}} = nomeCliente, {{2}} = valor, {{3}} = data, {{4}} = nomeAssinante
    const parameters = [
      { type: 'text', text: nomeCliente },
      { type: 'text', text: valor },
      { type: 'text', text: dataVencimento },
      { type: 'text', text: nomeAssinante }
    ]

    return await this.enviarTemplate(telefone, templateName, parameters, 'pt_BR')
  }
}

const wabaService = new WABAService()
export default wabaService
